import { AxiosResponse } from "axios";
// APIs
import * as promotionsAPI from "src/apis/promotions.api";

// Constants
import { PromotionPriceType } from "src/constants";

// Helpers
import { AxiosCustomResponse } from "src/helpers/axios.helper";
import { getPaginationFromHeader } from "src/helpers/common.helper";

export const fetchPromotions = async (
    params: FetchPromotionsRequestParams
): Promise<
    AxiosCustomResponse<{ data: Promotion[]; pagination: Pagination }>
> => {
    const { payload, response } = await promotionsAPI.fetchPromotions(params);

    const pagination = getPaginationFromHeader(
        response as AxiosResponse,
        params.limit ?? 10
    );

    return {
        payload: {
            data: (payload ?? []).map(_transformPromotionResponse),
            pagination,
        },
        success: true,
    };
};

export const initialPromotionDetailPage = async (
    id: number
): Promise<{ data: Promotion; promotions: Promotion[] } | undefined> => {
    const [detailResponse, promotionsRespones] = await Promise.all([
        promotionsAPI.fetchPromotion(id, undefined, { notiOnError: false }),
        promotionsAPI.fetchPromotions({
            status: true,
            is_exclude_expired: true,
            limit: 3,
            offset: 0,
            exclude_ids: [id],
        }),
    ]);

    if (!detailResponse.success || !detailResponse.payload) {
        return undefined;
    }

    return {
        data: _transformPromotionResponse(detailResponse.payload),
        promotions: (promotionsRespones.payload ?? []).map(
            _transformPromotionResponse
        ),
    };
};

const _transformPromotionResponse = ({
    promotion_id: id,
    name,
    image_url: imageUrl,
    amount,
    promotion_code: promotionCode,
    expiration_date: endAt,
    is_new: isNew = false,
    description,
}: PromotionResponse): Promotion => ({
    id,
    name,
    imageUrl,
    price: parseFloat(amount),
    priceType: PromotionPriceType.PER_DAY,
    promotionCode,
    endAt,
    isNew,
    description,
});
